import { bypass, http, HttpResponse } from 'msw';

export const eInvoicingHandlers = [
  http.get(/\/api\/v1\/document_relations(?:\?.*)?$/, async ({ request }) => {
    const response = await fetch(bypass(request));

    const url = new URL(request.url);

    // Read the "id" URL query parameter using the "URLSearchParams" API.
    // Given "/product?id=1", "productId" will equal "1".
    const annotationId = url.searchParams.get('annotation');

    const results = [
      {
        id: 1500,
        type: 'export',
        key: null,
        annotation: `https://elis.develop.r8.lol/api/v1/annotations/${annotationId}`,
        documents: ['https://elis.develop.r8.lol/api/v1/documents/6867175'],
        url: 'https://elis.develop.r8.lol/api/v1/document_relations/1500',
      },
    ];

    const originalResponse = await response.json();

    return HttpResponse.json({
      ...originalResponse,
      results,
    });
  }),
];
